import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ShieldCheckIcon, HeartIcon, ZapIcon, LockIcon, TrendingUpIcon } from 'lucide-react';
const features = [{
  icon: ClockIcon,
  title: 'Lightning Fast Setup',
  description: 'Go live in 30 minutes. No lengthy approval processes or complex setup. Start accepting donations today.',
  gradient: 'from-blue-500 to-cyan-500'
}, {
  icon: ShieldCheckIcon,
  title: 'Bank-Level Security',
  description: "Full PCI compliance with industry-leading encryption. Your donors' data is protected with the same security used by major banks.",
  gradient: 'from-green-500 to-emerald-500'
}, {
  icon: HeartIcon,
  title: 'Built by Nonprofits',
  description: "We're a nonprofit helping nonprofits. We understand your mission because we share it. No profit-driven motives.",
  gradient: 'from-pink-500 to-rose-500'
}, {
  icon: ZapIcon,
  title: 'Instant Payouts',
  description: 'Funds hit your account immediately. No waiting periods, no delays. Get your money when you need it.',
  gradient: 'from-yellow-500 to-orange-500'
}, {
  icon: LockIcon,
  title: 'Zero Hidden Fees',
  description: 'Simple, transparent pricing with no surprises. What you see is what you pay. No setup fees, no monthly fees.',
  gradient: 'from-purple-500 to-indigo-500'
}, {
  icon: TrendingUpIcon,
  title: 'Smart Analytics',
  description: 'Understand your donors with powerful insights. Track campaigns, optimize fundraising, and grow your impact.',
  gradient: 'from-orange-500 to-pink-500'
}];
export function FeatureGrid() {
  return <section className="py-24 lg:py-32 bg-white relative overflow-hidden" data-id="element-64">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl" data-id="element-65" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" data-id="element-66" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-68">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full mb-6" data-id="element-69">
            <span className="text-sm font-semibold text-orange-600" data-id="element-70">
              Everything you need
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4" data-id="element-71">
            Powerful features for nonprofits
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-72">
            Built specifically for nonprofit organizations who need to move fast
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-73">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative" data-id="element-74">
              <div className="relative bg-white rounded-2xl p-8 border-2 border-slate-200 hover:border-slate-300 transition-all h-full" data-id="element-75">
                <div className={`inline-flex p-4 rounded-2xl bg-gradient-to-br ${feature.gradient} mb-6 shadow-lg`} data-id="element-76">
                  <feature.icon className="w-6 h-6 text-white" data-id="element-77" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-78">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-79">
                  {feature.description}
                </p>

                {/* Hover gradient effect */}
                <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${feature.gradient} opacity-0 group-hover:opacity-5 transition-opacity -z-10`} data-id="element-80" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}